import Cookies from 'js-cookie'

class LocalStorage {
  get (key) {
    try {
      return localStorage.getItem(key)
    } catch (e) {
      return Cookies.get(key)
    }
  }

  set (key, value) {
    try {
      localStorage.setItem(key, value)
    } catch (e) {
      Cookies.set(key, value)
    }
  }

  remove (key) {
    try {
      localStorage.removeItem(key)
    } catch (e) {
      Cookies.remove(key)
    }
  }
}

export default new LocalStorage()



// WEBPACK FOOTER //
// ./src/helpers/StorageHelper.js